export default __webpack_public_path__ + "static/patientRelaxing-f17c42a5dea0a1fa4a3ba046a528f21a.jpg";